/* eslint-disable prefer-spread, prefer-rest-params */
function copyContextData(contexts, target) {
    contexts.forEach((context) => {
        Object.keys(context).forEach((prop) => {
            target[prop] = context[prop];
        });
    });
}
function mergeContexts(...args) {
    const ret = {};
    for (let i = 0; i < args.length; ++i) {
        let contextsOrPOJO = arguments[i];
        if (typeof contextsOrPOJO !== 'object' || contextsOrPOJO === null) {
            continue;
        }
        if (!Array.isArray(contextsOrPOJO)) {
            contextsOrPOJO = [contextsOrPOJO];
        }
        copyContextData(contextsOrPOJO, ret);
    }
    return ret;
}
function defaultSerializer(context, prop, value) {
    context[prop] = value;
}
function NodeContext() {
    this.context = this.context || {};
}
NodeContext.prototype.setContext = function setContext(propOrObject, value, serializer = defaultSerializer) {
    const context = this.context;
    let object = {};
    if (typeof propOrObject !== 'object') {
        object[propOrObject] = value;
    }
    else if (propOrObject !== null) {
        object = propOrObject;
    }
    Object.keys(object).forEach((prop) => {
        serializer(context, prop, object[prop]);
    });
};
NodeContext.prototype.getContext = function getContext(prop) {
    const context = this.context;
    let value;
    if (prop === undefined) {
        return this.getFullNodeContext(true);
    }
    if (context.hasOwnProperty(prop)) {
        value = context[prop];
    }
    else {
        if (this.parent) {
            value = this.parent.getContext(prop);
        }
        else if (this !== this.root) {
            value = this.root.getContext(prop);
        }
    }
    return value;
};
NodeContext.prototype.deleteContext = function deleteContext(prop) {
    const context = this.context;
    if (context.hasOwnProperty(prop)) {
        delete context[prop];
    }
};
NodeContext.prototype.getFullNodeContext = function getFullNodeContext(includeRoot) {
    const contexts = [];
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let currentNode = this;
    while (currentNode) {
        if (currentNode !== currentNode.root)
            contexts.push(currentNode.context);
        currentNode = currentNode.parent;
    }
    // Include root by default if we are the root
    if (includeRoot === true || (includeRoot === undefined && this === this.root)) {
        contexts.push(this.root.context);
    }
    return mergeContexts.apply(null, contexts.reverse());
};
export default {
    pluginName: 'context',
    dependencies: ['parent'],
    nodeInit: NodeContext,
    nodeMethods: NodeContext.prototype,
    // Static plugin methods
    mergeContexts: mergeContexts,
};
//# sourceMappingURL=context.js.map